import { co as O, cp as k, cq as E, cr as y, cs as X, ct as L, cu as M, cv as I, cw as g, cx as S, cy as D, cz as _, cA as H, cB as F, cC as K, cD as U, cE as C, cF as z, cG as j, cH as q, cI as G } from "./address-CmQhtpW5.mjs";
const V = /* @__PURE__ */ Uint8Array.from([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  // Blake1, unused in others
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9
]), f = /* @__PURE__ */ Uint32Array.from([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), t = /* @__PURE__ */ new Uint32Array(32);
function w(b, s, h, n, o, l) {
  const i = o[l], e = o[l + 1];
  let r = t[2 * b], v = t[2 * b + 1], a = t[2 * s], c = t[2 * s + 1], p = t[2 * h], B = t[2 * h + 1], d = t[2 * n], u = t[2 * n + 1], x = G(r, a, i);
  v = H(x, v, c, e), r = x | 0, { Dh: u, Dl: d } = { Dh: u ^ v, Dl: d ^ r }, { Dh: u, Dl: d } = { Dh: K(u, d), Dl: F(u) }, { h: B, l: p } = U(B, p, u, d), { Bh: c, Bl: a } = { Bh: c ^ B, Bl: a ^ p }, { Bh: c, Bl: a } = { Bh: z(c, a, 24), Bl: C(c, a, 24) }, t[2 * b] = r, t[2 * b + 1] = v, t[2 * s] = a, t[2 * s + 1] = c, t[2 * h] = p, t[2 * h + 1] = B, t[2 * n] = d, t[2 * n + 1] = u;
}
function A(b, s, h, n, o, l) {
  const i = o[l], e = o[l + 1];
  let r = t[2 * b], v = t[2 * b + 1], a = t[2 * s], c = t[2 * s + 1], p = t[2 * h], B = t[2 * h + 1], d = t[2 * n], u = t[2 * n + 1], x = G(r, a, i);
  v = H(x, v, c, e), r = x | 0, { Dh: u, Dl: d } = { Dh: u ^ v, Dl: d ^ r }, { Dh: u, Dl: d } = { Dh: z(u, d, 16), Dl: C(u, d, 16) }, { h: B, l: p } = U(B, p, u, d), { Bh: c, Bl: a } = { Bh: c ^ B, Bl: a ^ p }, { Bh: c, Bl: a } = { Bh: q(c, a, 63), Bl: j(c, a, 63) }, t[2 * b] = r, t[2 * b + 1] = v, t[2 * s] = a, t[2 * s + 1] = c, t[2 * h] = p, t[2 * h + 1] = B, t[2 * n] = d, t[2 * n + 1] = u;
}
function $(b, s = {}, h, n, o) {
  if (I(h), b < 0 || b > h)
    throw new Error("outputLen bigger than keyLen");
  const { key: l, salt: i, personalization: e } = s;
  if (l !== void 0 && (l.length < 1 || l.length > h))
    throw new Error("key length must be undefined or 1.." + h);
  if (i !== void 0 && i.length !== n)
    throw new Error("salt must be undefined or " + n);
  if (e !== void 0 && e.length !== o)
    throw new Error("personalization must be undefined or " + o);
}
class J extends M {
  constructor(s, h) {
    super(), this.finished = !1, this.destroyed = !1, this.length = 0, this.pos = 0, I(s), I(h), this.blockLen = s, this.outputLen = h, this.buffer = new Uint8Array(s), this.buffer32 = E(this.buffer);
  }
  update(s) {
    g(this), s = k(s), S(s);
    const { blockLen: h, buffer: n, buffer32: o } = this, l = s.length, i = s.byteOffset, e = s.buffer;
    for (let r = 0; r < l; ) {
      this.pos === h && (D(o), this.compress(o, 0, !1), D(o), this.pos = 0);
      const v = Math.min(h - this.pos, l - r), a = i + r;
      if (v === h && !(a % 4) && r + v < l) {
        const c = new Uint32Array(e, a, Math.floor((l - r) / 4));
        D(c);
        for (let p = 0; r + h < l; p += o.length, r += h)
          this.length += h, this.compress(c, p, !1);
        D(c);
        continue;
      }
      n.set(s.subarray(r, r + v), this.pos), this.pos += v, this.length += v, r += v;
    }
    return this;
  }
  digestInto(s) {
    g(this), _(s, this);
    const { pos: h, buffer32: n } = this;
    this.finished = !0, L(this.buffer.subarray(h)), D(n), this.compress(n, 0, !0), D(n);
    const o = E(s);
    this.get().forEach((l, i) => o[i] = y(l));
  }
  digest() {
    const { buffer: s, outputLen: h } = this;
    this.digestInto(s);
    const n = s.slice(0, h);
    return this.destroy(), n;
  }
  _cloneInto(s) {
    const { buffer: h, length: n, finished: o, destroyed: l, outputLen: i, pos: e } = this;
    return s || (s = new this.constructor({ dkLen: i })), s.set(...this.get()), s.buffer.set(h), s.destroyed = l, s.finished = o, s.length = n, s.pos = e, s.outputLen = i, s;
  }
  clone() {
    return this._cloneInto();
  }
}
class N extends J {
  constructor(s = {}) {
    const h = s.dkLen === void 0 ? 64 : s.dkLen;
    super(128, h), this.v0l = f[0] | 0, this.v0h = f[1] | 0, this.v1l = f[2] | 0, this.v1h = f[3] | 0, this.v2l = f[4] | 0, this.v2h = f[5] | 0, this.v3l = f[6] | 0, this.v3h = f[7] | 0, this.v4l = f[8] | 0, this.v4h = f[9] | 0, this.v5l = f[10] | 0, this.v5h = f[11] | 0, this.v6l = f[12] | 0, this.v6h = f[13] | 0, this.v7l = f[14] | 0, this.v7h = f[15] | 0, $(h, s, 64, 16, 16);
    let { key: n, personalization: o, salt: l } = s, i = 0;
    if (n !== void 0 && (n = k(n), i = n.length), this.v0l ^= this.outputLen | i << 8 | 65536 | 1 << 24, l !== void 0) {
      l = k(l);
      const e = E(l);
      this.v4l ^= y(e[0]), this.v4h ^= y(e[1]), this.v5l ^= y(e[2]), this.v5h ^= y(e[3]);
    }
    if (o !== void 0) {
      o = k(o);
      const e = E(o);
      this.v6l ^= y(e[0]), this.v6h ^= y(e[1]), this.v7l ^= y(e[2]), this.v7h ^= y(e[3]);
    }
    if (n !== void 0) {
      const e = new Uint8Array(this.blockLen);
      e.set(n), this.update(e);
    }
  }
  // prettier-ignore
  get() {
    let { v0l: s, v0h: h, v1l: n, v1h: o, v2l: l, v2h: i, v3l: e, v3h: r, v4l: v, v4h: a, v5l: c, v5h: p, v6l: B, v6h: d, v7l: u, v7h: x } = this;
    return [s, h, n, o, l, i, e, r, v, a, c, p, B, d, u, x];
  }
  // prettier-ignore
  set(s, h, n, o, l, i, e, r, v, a, c, p, B, d, u, x) {
    this.v0l = s | 0, this.v0h = h | 0, this.v1l = n | 0, this.v1h = o | 0, this.v2l = l | 0, this.v2h = i | 0, this.v3l = e | 0, this.v3h = r | 0, this.v4l = v | 0, this.v4h = a | 0, this.v5l = c | 0, this.v5h = p | 0, this.v6l = B | 0, this.v6h = d | 0, this.v7l = u | 0, this.v7h = x | 0;
  }
  compress(s, h, n) {
    this.get().forEach((r, v) => t[v] = r), t.set(f, 16);
    let { h: o, l } = X(BigInt(this.length));
    t[24] = f[8] ^ l, t[25] = f[9] ^ o, n && (t[28] = ~t[28], t[29] = ~t[29]);
    let i = 0;
    const e = V;
    for (let r = 0; r < 12; r++)
      w(0, 4, 8, 12, s, h + 2 * e[i++]), A(0, 4, 8, 12, s, h + 2 * e[i++]), w(1, 5, 9, 13, s, h + 2 * e[i++]), A(1, 5, 9, 13, s, h + 2 * e[i++]), w(2, 6, 10, 14, s, h + 2 * e[i++]), A(2, 6, 10, 14, s, h + 2 * e[i++]), w(3, 7, 11, 15, s, h + 2 * e[i++]), A(3, 7, 11, 15, s, h + 2 * e[i++]), w(0, 5, 10, 15, s, h + 2 * e[i++]), A(0, 5, 10, 15, s, h + 2 * e[i++]), w(1, 6, 11, 12, s, h + 2 * e[i++]), A(1, 6, 11, 12, s, h + 2 * e[i++]), w(2, 7, 8, 13, s, h + 2 * e[i++]), A(2, 7, 8, 13, s, h + 2 * e[i++]), w(3, 4, 9, 14, s, h + 2 * e[i++]), A(3, 4, 9, 14, s, h + 2 * e[i++]);
    this.v0l ^= t[0] ^ t[16], this.v0h ^= t[1] ^ t[17], this.v1l ^= t[2] ^ t[18], this.v1h ^= t[3] ^ t[19], this.v2l ^= t[4] ^ t[20], this.v2h ^= t[5] ^ t[21], this.v3l ^= t[6] ^ t[22], this.v3h ^= t[7] ^ t[23], this.v4l ^= t[8] ^ t[24], this.v4h ^= t[9] ^ t[25], this.v5l ^= t[10] ^ t[26], this.v5h ^= t[11] ^ t[27], this.v6l ^= t[12] ^ t[28], this.v6h ^= t[13] ^ t[29], this.v7l ^= t[14] ^ t[30], this.v7h ^= t[15] ^ t[31], L(t);
  }
  destroy() {
    this.destroyed = !0, L(this.buffer32), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const P = /* @__PURE__ */ O((b) => new N(b)), R = P;
export {
  R as b
};
